/* SteloSupps Produktkarte (Lovable-Stil) – 24.09.2026. Ein Listener für alle Karten der Seite. */
(function () {
  if (window.__steloCard) return;
  window.__steloCard = true;
  var isEn = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var addedText = isEn ? 'Added' : 'Hinzugefügt';
  var errorText = isEn ? 'That did not work. Please open the product.' : 'Das hat nicht geklappt. Bitte öffne das Produkt.';
  var root = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');
  var status = null;
  function say(t) {
    if (!status) { status = document.createElement('p'); status.className = 'sa-card-status'; status.setAttribute('role', 'status'); document.body.appendChild(status); }
    status.textContent = t;
  }
  function applyUnit(card, pack) {
    var el = card.querySelector('[data-sa-unit]');
    if (el) el.textContent = [pack.dataset.per, pack.dataset.unit].filter(Boolean).join(' · ');
  }
  function init(scope) {
    (scope || document).querySelectorAll('[data-sa-card]').forEach(function (card) {
      if (card.dataset.saReady) return; card.dataset.saReady = '1';
      var p = card.querySelector('.sa-card__pack[aria-pressed="true"]');
      if (p) applyUnit(card, p);
    });
  }
  document.addEventListener('click', function (e) {
    var pack = e.target.closest('.sa-card__pack');
    if (pack) {
      if (pack.disabled) return;
      var card = pack.closest('[data-sa-card]');
      card.querySelectorAll('.sa-card__pack').forEach(function (b) { b.setAttribute('aria-pressed', b === pack ? 'true' : 'false'); });
      card.querySelector('[data-sa-price]').textContent = pack.dataset.price;
      card.querySelector('[data-sa-compare]').textContent = pack.dataset.compare || '';
      applyUnit(card, pack);
      var btn = card.querySelector('[data-sa-add]'); if (btn) btn.dataset.variant = pack.dataset.variant;
      e.preventDefault(); e.stopPropagation();
      return;
    }
    var add = e.target.closest('[data-sa-add]');
    if (!add) return;
    e.preventDefault(); e.stopPropagation();
    if (add.disabled) return;
    var label = add.querySelector('[data-sa-add-text]');
    var base = add.dataset.label || (label && label.textContent);
    add.disabled = true;
    fetch(root + '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(add.dataset.variant, 10), quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw new Error('add'); return fetch(root + '/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (label) label.textContent = addedText; say(addedText);
        document.querySelectorAll('.cart-bubble__text-count, [data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'stelo-card', data: { itemCount: cart.item_count, source: 'stelo-card' } } }));
        setTimeout(function () { add.disabled = false; if (label) label.textContent = base; }, 2200);
      })
      .catch(function () { add.disabled = false; if (label) label.textContent = base; say(errorText); });
  }, true);
  /* Judge.me-Karussell: Überschrift in Du-Ansprache (24.09.2026) */
  function fixReviewTitle() {
    if (isEn) return;
    document.querySelectorAll('.jdgm-carousel-title').forEach(function (h) {
      if (/Lassen Sie Kunden/.test(h.textContent)) h.textContent = 'Das sagen unsere Kundinnen und Kunden';
    });
  }
  function reviewMore() {
    document.querySelectorAll('.jdgm-carousel-item__review-body.jdgm-line-clamp').forEach(function (b) {
      if (b.dataset.saMore) return;
      if (b.scrollHeight <= b.clientHeight + 2) return;
      b.dataset.saMore = '1';
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'stelo-rev-more';
      btn.textContent = isEn ? 'Read more' : 'Mehr lesen';
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var open = b.classList.toggle('is-open');
        btn.textContent = open ? (isEn ? 'Show less' : 'Weniger') : (isEn ? 'Read more' : 'Mehr lesen');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      b.insertAdjacentElement('afterend', btn);
    });
  }
  /* Handy-Menü (16.10.2026): Hauptpunkt mit Unterpunkten wird selbst zum Link auf die Übersichtsseite,
     das Plus klappt weiter auf; der Extra-Eintrag „Zur Übersicht“ entfällt. Ohne JS bleibt er als Rückfall. */
  function drawerLinks() {
    document.querySelectorAll('accordion-custom details .menu-drawer__list-item--overview').forEach(function (li) {
      var a = li.querySelector('a[href]');
      var details = li.closest('details');
      var sum = details && details.querySelector(':scope > summary');
      var txt = sum && sum.querySelector('.menu-drawer__menu-item-text');
      if (!a || !txt) return;
      if (txt.tagName !== 'A') {
        var link = document.createElement('a');
        link.href = a.getAttribute('href');
        link.className = txt.className + ' stelo-drawer-mainlink';
        link.style.cssText = 'color:inherit;text-decoration:none;flex:1 1 auto;';
        link.textContent = txt.textContent;
        if (a.hasAttribute('aria-current')) link.setAttribute('aria-current', 'page');
        txt.replaceWith(link);
      }
      li.remove();
    });
  }
  var _init = init;
  init = function (scope) { _init(scope); fixReviewTitle(); reviewMore(); drawerLinks(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  new MutationObserver(function () { init(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
